import BodyText, { BODY_TEXT_SIZES } from "@shared/ui/BodyText";
import AppModal from "@shared/ui/Modal";
import React from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

export const LoginAlert = ({
  onClose,
  portalSlug,
}: {
  onClose: () => void;
  /** OEM portal slug — redirects to branded portal login when present */
  portalSlug?: string;
}) => {
  const intl = useIntl();
  const { messages } = intl;
  const navigate = useNavigate();

  const loginPath = portalSlug ? `/customer-portal/${portalSlug}` : "/oem";

  return (
    <AppModal
      isOpen={true}
      handleClose={onClose}
      cancelButtonText={messages?.common?.["okay"]}
      handleSubmit={() => navigate(loginPath)}
      updateButtonText={messages?.common?.["login"]}
      title={messages?.common?.["login"]}
      content={
        <>
          <BodyText size={BODY_TEXT_SIZES.X_SMALL}>
            {messages?.["hierarchy"]?.["assets"]?.["restrictedAssetLogin"]}
          </BodyText>
        </>
      }
    />
  );
};
